module.exports = __webpack_public_path__ + "static/media/log-out-of-paypal.186333e5.png";